import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, effect, input, signal, ViewEncapsulation } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IMenuItem } from '../custom-side-nav.component';

@Component({
    selector: 'side-nav-menu',
    templateUrl: './side-nav-menu.component.html',
    styleUrl: './side-nav-menu.component.scss',
    standalone: true,
    imports: [CommonModule, MatListModule, MatMenuModule, NgOptimizedImage, RouterLink, RouterLinkActive, TranslateModule],
    encapsulation: ViewEncapsulation.None
})
export class SideNavMenuComponent {
    collapsed = input(false);
    item = input.required<IMenuItem>();
    level = input.required<number>();
    nestedMenuOpen = signal(false);

    constructor(public router: Router) {
        effect(() => {
            if (this.collapsed()) {
                this.nestedMenuOpen.set(false);
            }
        }, { allowSignalWrites: true });
    }

    itemClasses(item: IMenuItem): Record<string, boolean> {
        const active = this.isActive(item);
        return {
            [`side-nav__item--level-${this.level()}`]: true,
            'side-nav__item--has-children': !!item.subItems,
            'side-nav__item--expanded': this.nestedMenuOpen(),
            'active': active,
            'active0': this.level() === 0 && active && !!item.subItems
        };
    }

    isActive(item: IMenuItem): boolean {
        const currentUrl = this.router.url.split('?')[0];
        if (item.route) {
            const itemRoute = item.route.startsWith('/') ? item.route : `/${item.route}`;
            return currentUrl === itemRoute || currentUrl.startsWith(`${itemRoute}/`);
        }
        if (item.subItems) {
            return item.subItems.some(sub => this.isActive(sub));
        }
        return false;
    }

    toggleNestedMenu(event: Event) {
        if (!this.item().subItems) {
            return;
        }
        event.stopPropagation();
        this.nestedMenuOpen.set(!this.nestedMenuOpen());
    }
}
